import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import ToolSafetyDisclaimer from '../components/tools/ToolSafetyDisclaimer';
import VoltageDropCalculator from '../components/tools/VoltageDropCalculator';

const VoltageDropCalculatorPage = () => {
  return (
    <div className="min-h-screen" data-testid="voltage-drop-calculator-page">
      <PageHero
        eyebrow="Engineering Utilities"
        title="Voltage Drop Calculator"
        description="Analyze voltage drop across an automotive circuit — cable, connector, fuse/relay, and ground — and get the minimum cable size that keeps it within your allowable limit."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="voltage-drop-calculator-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <ToolSafetyDisclaimer standards="the conductor-resistance formula R = ρL/A with typical material resistivities" />
          <VoltageDropCalculator />
          <ToolGuideCta guidePath="/tools/voltage-drop-calculator/guide" toolName="Voltage Drop Calculator" />
        </div>
      </section>
    </div>
  );
};

export default VoltageDropCalculatorPage;
